"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "VersionModel", {
    enumerable: true,
    get: function() {
        return VersionModel;
    }
});
const _zod = require("zod");
const _metadatamodel = require("../metadata-model");
const _versionfailurereason = require("./version-failure-reason");
const _versionstatus = require("./version-status");
const VersionModel = _metadatamodel.MetadataModel.merge(_zod.z.object({
    id: _zod.z.string({
        description: 'The unique identifier of the version.'
    }).ulid(),
    instructionId: _zod.z.string({
        description: 'The unique identifier of the instruction.'
    }).ulid(),
    configurationId: _zod.z.string({
        description: 'The unique identifier of the configuration.'
    }).ulid(),
    configurationVersionId: _zod.z.number({
        description: 'The unique identifier of the configuration version.'
    }).int(),
    versionNumber: _zod.z.number({
        description: 'The number of the version.'
    }),
    description: _zod.z.string({
        description: 'The description of the version.'
    }).optional(),
    status: _zod.z.union([
        _zod.z.literal(_versionstatus.VersionStatus.Draft),
        _zod.z.literal(_versionstatus.VersionStatus.Published),
        _zod.z.literal(_versionstatus.VersionStatus.Duplicating),
        _zod.z.literal(_versionstatus.VersionStatus.Failed)
    ], {
        description: 'The status of the version.'
    }),
    failureReason: _zod.z.union([
        _zod.z.literal(_versionfailurereason.VersionFailureReason.ValidationError),
        _zod.z.literal(_versionfailurereason.VersionFailureReason.VersionLanguagesError),
        _zod.z.literal(_versionfailurereason.VersionFailureReason.SegmentsError),
        _zod.z.literal(_versionfailurereason.VersionFailureReason.Unknown)
    ], {
        description: 'The reason that an operation on a version failed.'
    }).optional(),
    authorUserId: _zod.z.string({
        description: 'The unique identifier of the author that created this version.'
    }).uuid(),
    authorName: _zod.z.string({
        description: 'The full name of the author that created this version.'
    }),
    cadFileName: _zod.z.string({
        description: 'The  name of the cad file associated with this version.'
    }),
    cadUploadDate: _zod.z.string({
        description: 'The date time the cad was uploaded at.'
    }).datetime()
}));

//# sourceMappingURL=version-model.js.map